//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import SaleDebitNoteCreateView from '@/views/Sale/SlSaleDebitNote/SlSaleDebitNoteCreate'
import SaleDebitNoteListView from '@/views/Sale/SlSaleDebitNote/SlSaleDebitNoteList'
import SaleDebitNoteUpdateView from '@/views/Sale/SlSaleDebitNote/SlSaleDebitNoteUpdate'

//
export default {
    path: 'sale_debit_notes',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'sale-debit-note-list',
            component: SaleDebitNoteListView,
        },
        {
            path: 'create',
            name: 'sale-debit-note-create',
            component: SaleDebitNoteCreateView,
            meta: {
                title: 'Crear nota de débito'
            },
        },
        {
            path: ':id',
            name: 'sale-debit-note-update',
            component: SaleDebitNoteUpdateView,
            meta: {
                title: 'Detalle nota de débito'
            },
        },
    ],
    meta: {
        title: 'Notas de débito',
    }

}